import i18n from '@/plugins/i18n';
import { TABLE_KEYS } from '@/utils/templates/databaseTemplate/database.constants';
const { LABEL, VALUE, TIMESTAMP, DEADLOCK } = TABLE_KEYS;

const myConnectionsTableHeaders = () => [
  {
    key: LABEL,
    name: i18n.global.t('dbm.connections.userName'),
    width: '40%',
    sortable: true,
  },
  {
    key: VALUE,
    width: '20%',
    name: i18n.global.t('dbm.connections.queriesExicuted'),
    sortable: true,
  },
  {
    key: TIMESTAMP,
    name: i18n.global.t('dbm.connections.timestamp'),
    width: '20%',
    sortable: true,
  },
  {
    key: DEADLOCK,
    name: i18n.global.t('dbm.deadlock'),
    width: '20%',
    sortable: true,
  },
];

export { myConnectionsTableHeaders };
